var map = {
	"./americanexpress.png": "0686",
	"./chip.png": "47be",
	"./diners-color.png": "b28e",
	"./diners.png": "22b2",
	"./lider-color.png": "b400",
	"./lider.png": "4869",
	"./master-color.png": "5e84",
	"./master.png": "24b0",
	"./mercadopago.png": "f6ac",
	"./oca-color.png": "a3fc",
	"./oca.png": "4a98",
	"./tarjeta.png": "4236",
	"./visa-color.png": "ebc0",
	"./visa.png": "bce3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6501";